<template>
  <div class="flex">
    <div class="branca">
      <v-container>
        <v-row class="mb-6" no-gutters>
          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="230" src="@/assets/img/dcomp.png" alt=""
            /></router-link>
          </v-col>

          <v-col cols="6">
            <router-link to="/login" style="text-decoration: none"
              ><img width="250" src="@/assets/img/logo_UFS.png" alt=""
            /></router-link>
          </v-col>
        </v-row>
      </v-container>
      <div class="div-esq">
        <v-sheet width="400" class="mx-auto">
          <h1 class="poppins400">Recuperação de senha</h1>
          <br />
          <div class="justify-content">
            <h4 class="poppins400">Insira o email abaixo para recuperá-lo.</h4>
            <h4 class="poppins400">
              Já recuperou? Você pode fazer login
              <router-link to="/login" style="text-decoration: none"
                >aqui</router-link
              >
            </h4>
            <br />
          </div>

          <v-form @submit.prevent="recuperarSenha()">
            <v-text-field
              v-model="email"
              required
              :rules="rules"
              variant="underlined"
              label="Insira seu email"
              prepend-inner-icon="mdi-email-outline"
            >
            </v-text-field
            ><br />

            <v-btn
              type="submit"
              block
              class="mt-2 button-config"
              rounded="pill"
            >
              Confirmar email
            </v-btn>

            <v-alert
              v-if="showAlert"
              :type="alertType"
              @input="showAlert = false"
              closable
              class="mt-2 text-left"
            >
              {{ alertMessage }}
            </v-alert>
          </v-form>
        </v-sheet>
      </div>
    </div>
    <div class="azul">
      <div class="div-dir">
        <img
          class="img-sispi"
          src="../assets/img/logo_dark_nobg.png"
          alt="SISGIP - Sistema de Gestão Integrada de Projetos"
        />
        <h1 class="texto-inicio">Bem-vindos ao SISGIP!</h1>
        <h1 class="texto-inicio">Sistema de Gestão Integrada de Projetos</h1>
        <br /><br />
        <h3 class="subtexto-inicio">
          Elevando a Gestão de Projetos a Novos Patamares.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/fonts.css';
import '@/assets/css/login-validacao-cadastro.css';
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  data() {
    return {
      email: '',
      showAlert: false,
    };
  },
  methods: {
    async recuperarSenha() {
      this.showAlert = false;
      const host = window.location.host;
      console.log(host);
      try {
        const response = await axios.post(
          `${API_URL}/usuarios/esqueci-minha-senha`,
          {
            email: this.email,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'X-Host': host,
            },
          },
        );
        this.showAlert = true;
        this.alertType = 'success';
        this.alertMessage = `Enviamos um link de recuperação para o seguinte email: ${this.email}.`;
        console.log(response);
      } catch (error) {
        this.showAlert = true;
        this.alertType = 'error';
        this.alertMessage = `${error.response.data.message}`;

        console.log(error);
      }
    },
  },
};
</script>

<style></style>
